import { render, staticRenderFns } from "./BlipMessageVolumeInPeriod.vue?vue&type=template&id=000a3d78&"
import script from "./BlipMessageVolumeInPeriod.vue?vue&type=script&lang=js&"
export * from "./BlipMessageVolumeInPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports